import React from 'react'
import Avatar from 'shared-web/src/components/Avatar'
import { getDisplayName } from 'shared-web/src/helpers/CustomerHelpers'

import PlaybookModal from '../PlaybookModal'
import CurrentTeamMembers from './CurrentTeamMembers'

import style from './style.styl'

const ExtensionInviteModal = ({
  onCloseClick,
  sendInvitationsViaEmail,
  sendInvitationsViaSlack,
  usersWithExtension,
}) => (
  <PlaybookModal
    title="Message"
    onCloseClick={onCloseClick}
    closeLabel="Close"
    showSaveStatus={false}
    contentClassName={style.ExtensionInviteModalContent}
    headerClassName={style.ExtensionInviteModalHeader}
    description={'Send From'}
  >
    <div className="extension-invite-wrapper drift-form flex-column">
      <div className="extension-invite-cta">Teammates who have the Drift Extension installed</div>
      <div className="flex existing-extension-avatar">
        {usersWithExtension
          .map(user => (
            <div
              key={user.id}
              title={getDisplayName(user)}
              style={{ marginRight: '5px', position: 'relative' }}
            >
              <Avatar user={user} />
            </div>
          ))
          .toArray()}
      </div>
      <hr />
      <CurrentTeamMembers />
    </div>
  </PlaybookModal>
)

export default ExtensionInviteModal



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/ExtensionInviteModal/component.js